import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IMarketTimePromiseLookupService } from "../IMarketTimePromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class MarketTimePromiseLookupService
  extends PromiseLookupService<string, CubiqTS.MarketTimeConstantImpl>
  implements IMarketTimePromiseLookupService
{
  constructor() {
    super();
    // debugger;
  }
  abstract getMarketTime(id: string): Promise<CubiqTS.MarketTimeConstantImpl>;
  abstract getAllMarketTime(): Promise<Array<string>>;
}
